import { styled } from 'baseui';
import React, { PropsWithChildren } from 'react';
import { Col, Row } from 'react-bootstrap';
import { getPixelSize, ICONSIZE } from './Icon';
import { md } from 'presentation/theme/mediaQueries';

const PlaceholderCol = styled(Col, {
  paddingTop: '4px',
  [md]: {
    paddingTop: '24px'
  }
});

interface Props {
  indented?: boolean;
}

const PageDescription: React.FC<PropsWithChildren<Props>> = ({ children, indented }) => {
  return (
    <Row className="justify-content-center">
      {!!indented && (
        <PlaceholderCol xs="auto">
          <div
            style={{
              width: getPixelSize(ICONSIZE.medium),
              height: getPixelSize(ICONSIZE.medium)
            }}
          ></div>
        </PlaceholderCol>
      )}

      <Col xs data-gi="page-description-element" className={!!indented ? 'px-0' : ''}>
        <p className="copy text-center">{children}</p>
      </Col>

      {!!indented && (
        <PlaceholderCol xs="auto">
          <div
            style={{
              width: getPixelSize(ICONSIZE.medium),
              height: getPixelSize(ICONSIZE.medium)
            }}
          ></div>
        </PlaceholderCol>
      )}
    </Row>
  );
};

export default PageDescription;
